export default "__VITE_ASSET__C8P3B7Wz__"